var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.value)?[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }